<template>
  <div class="price-check-page">
    <div class="page-header">
      <h1>Проверка стоимости АТИ</h1>
    </div>

    <div class="tab-bar">
      <button
        v-for="t in tabs"
        :key="t.key"
        :class="['tab-btn', { 'tab-active': activeTab === t.key }]"
        @click="selectTab(t.key)"
      >
        {{ t.label }}
      </button>
    </div>

    <div class="tab-content">
      <RoutesStatusTable v-if="mountedTabs.has('routes')" v-show="activeTab === 'routes'" />
      <BudgetDashboard v-if="mountedTabs.has('budget')" v-show="activeTab === 'budget'" />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import RoutesStatusTable from './price-check/RoutesStatusTable.vue'
import BudgetDashboard from './price-check/BudgetDashboard.vue'

const TABS = [
  { key: 'routes', label: 'Направления' },
  { key: 'budget', label: 'Бюджет / Отладка' },
]

const VALID = new Set(TABS.map((t) => t.key))

export default {
  name: 'PriceCheck',
  components: { RoutesStatusTable, BudgetDashboard },
  setup() {
    const route = useRoute()
    const router = useRouter()

    const activeTab = ref(VALID.has(route.query.tab) ? route.query.tab : 'routes')
    const mountedTabs = reactive(new Set(['routes']))

    const ensureMounted = (key) => {
      if (!mountedTabs.has(key)) mountedTabs.add(key)
    }

    const selectTab = (key) => {
      activeTab.value = key
      ensureMounted(key)
      const query = { ...route.query, tab: key }
      router.replace({ query })
    }

    watch(activeTab, (key) => ensureMounted(key))

    watch(() => route.query.tab, (tab) => {
      if (VALID.has(tab) && tab !== activeTab.value) {
        activeTab.value = tab
        ensureMounted(tab)
      }
    })

    onMounted(() => {
      ensureMounted(activeTab.value)
      if (!route.query.tab) {
        router.replace({ query: { ...route.query, tab: activeTab.value } })
      }
    })

    return { tabs: TABS, activeTab, mountedTabs, selectTab }
  },
}
</script>

<style scoped>
.price-check-page {
  padding: 24px;
  background: #f5f7fb;
  min-height: calc(100vh - 60px);
}

.page-header {
  margin-bottom: 18px;
}

.page-header h1 {
  margin: 0;
  color: #1d2b44;
  font-size: 26px;
}

.tab-bar {
  display: flex;
  gap: 6px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e1e8f1;
  flex-wrap: wrap;
}

.tab-btn {
  padding: 11px 18px;
  border: none;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #56657a;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
}

.tab-btn:hover {
  color: #1d2b44;
}

.tab-active {
  color: #3f6fb5;
  border-bottom-color: #3f6fb5;
}

.tab-content {
  min-height: 200px;
}
</style>
